import { ApplicationLocalizedDetail } from 'types/Application'
import { getProductFamilyName } from 'utils/getProductNames'

export const getApplicationName = (localizedDetails: ApplicationLocalizedDetail[], locale: string) => {
  const detail = localizedDetails?.find(
    (detail: ApplicationLocalizedDetail) => detail.language.replace('-', '_') === locale,
  )
  if (detail?.name.toLowerCase().includes('resolve')) {
    return getProductFamilyName('gotoresolve')
  } else if (detail?.name.match(/^GoTo\S/)) {
    return detail.name.replace('GoTo', 'GoTo ')
  }
  return detail?.name || ''
}
